import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogout, verifyAdminToken } from '../services/adminApi';
import AdminSettings from './AdminSettings';
import AdminGallery from './AdminGallery';
import AdminMessages from './AdminMessages';
import AdminAnalytics from './AdminAnalytics';
import '../styles/admin.css';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('analytics');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      const result = await verifyAdminToken();
      if (!result) {
        navigate('/admin/login');
      } else {
        setUsername(result.username);
        setLoading(false);
      }
    };
    verify();
  }, [navigate]);

  const handleLogout = () => {
    adminLogout();
    navigate('/admin/login');
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="admin-container">
      <header className="admin-header">
        <h1 className="admin-header-title">Admin Panel</h1>
        <div className="admin-header-actions">
          <span className="admin-user">Logged in as: {username}</span>
          <button className="admin-logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </header>

      <nav className="admin-tabs">
        <button
          className={`admin-tab ${activeTab === 'analytics' ? 'active' : ''}`}
          onClick={() => setActiveTab('analytics')}
          data-testid="tab-analytics"
        >
          Analytics
        </button>
        <button
          className={`admin-tab ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
          data-testid="tab-settings"
        >
          Settings
        </button>
        <button
          className={`admin-tab ${activeTab === 'gallery' ? 'active' : ''}`}
          onClick={() => setActiveTab('gallery')}
          data-testid="tab-gallery"
        >
          Gallery
        </button>
        <button
          className={`admin-tab ${activeTab === 'messages' ? 'active' : ''}`}
          onClick={() => setActiveTab('messages')}
          data-testid="tab-messages"
        >
          Messages
        </button>
      </nav>

      <div className="admin-content">
        {activeTab === 'analytics' && <AdminAnalytics />}
        {activeTab === 'settings' && <AdminSettings />}
        {activeTab === 'gallery' && <AdminGallery />}
        {activeTab === 'messages' && <AdminMessages />}
      </div>
    </div>
  );
};

export default AdminDashboard;